import { Button } from "@/components/ui/button";
import { SignInLink } from "@/components/auth/sign-in-link";

export function GuestAccountLinks({ sessionPending = false }: { sessionPending?: boolean }) {
  const hiddenForSession = sessionPending ? "in-data-[session]:invisible" : undefined;
  return (
    <>
      <Button variant="ghost" asChild size="default" className={hiddenForSession}>
        <SignInLink href="/sign-in">Log in</SignInLink>
      </Button>
      <Button variant="outline" asChild size="default" className={hiddenForSession}>
        <SignInLink href="/sign-up">Sign up</SignInLink>
      </Button>
    </>
  );
}
